import {useNotifications} from '@/data/Content/Notifications';
import {usePersonInfo} from '@/data/Content/PersonInfo';

export const useSuccessLoginNotify = () => {
	const {showSuccessUserLogin} = useNotifications();
	const {mutatePersonInfo} = usePersonInfo();


	const showSuccessAuthUser = async () => {
		const data = await mutatePersonInfo();
		showSuccessUserLogin(data?.firstName ?? '');
	};

	return {
		showSuccessAuthUser,
	};
};
